<template>
  <v-card
    class="mx-auto py-2 px-6"
    style="border-radius: 6px; position: relative"
    max-width="100%"
    v-if="!loading"
  >
    <v-btn absolute top right icon @click="close" style="z-index: 10">
      <v-icon color="#888">mdi-close</v-icon>
    </v-btn>

    <v-row class="ma-0 mt-4" style="min-height: -webkit-fill-available">
      <v-col class="ma-0 text-center" cols="12" md="2" sm="3">
        <div class="image-carousel">
          <v-img
            :id="'image' + i"
            v-for="(image, i) in product.images"
            :key="i"
            :src="env_url + image.path"
            reverse-transition="fade-transition"
            transition="fade-transition"
            class="img mb-3"
            contain
            max-height="120"
            @click="chooseSelectedImg(i)"
          ></v-img>
        </div>

        <v-btn elevation="0" color="#d76666" class="mt-2" @click="scrollBottom">
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </v-col>

      <v-col cols="12" md="6" sm="6">
        <v-img
          :src="env_url + product.images[0].path"
          contain
          max-width="580"
        ></v-img>
      </v-col>

      <v-col
        class="d-flex flex-column justify-space-around"
        cols="12"
        md="4"
        sm="6"
      >
        <div>
          <span class="ProductName pb-4 ma-0 pa-0">
            {{ product.productName }}
          </span>

          <br />

          <span class="ProductCode pa-0 pb-3">
            COD-{{ product.productCode }}
          </span>
        </div>

        <div class="attributes">
          <v-row v-for="(attr, i) in attributes" :key="i">
            <v-col cols="12" md="12" sm="12" v-if="attr.type == 'Cor'">
              <span class="label"> {{ attr.name }} </span>

              <v-sheet class="mx-auto" elevation="0" max-width="100%">
                <v-slide-group
                  v-model="model"
                  class="pa-0 MA-0"
                  center-active
                  show-arrows
                >
                  <v-slide-item
                    v-for="color in attr.hex"
                    :key="color"
                    v-slot="{ active }"
                  >
                    <!-- TODO:Alterar a cor aqui -->
                    <v-card
                      :color="color"
                      class="ma-1 PA-0"
                      height="40"
                      width="33"
                    >
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center"
                      >
                        <v-scale-transition>
                          <v-icon
                            v-if="active"
                            color="white"
                            size="20"
                            v-text="'mdi-bookmark-check-outline'"
                          ></v-icon>
                        </v-scale-transition>
                      </v-row>
                    </v-card>
                  </v-slide-item>
                </v-slide-group>
              </v-sheet>
            </v-col>

            <v-col v-if="attr.type == 'Texto'">
              <span class="label"> {{ attr.name }} </span>

              <div class="values-row">
                <div
                  class="attr-item mr-2"
                  v-for="value in attr.values"
                  :key="value"
                >
                  {{ value }}
                </div>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
        </div>

        <div class="d-flex justify-end">
          <v-btn
            class="btn-add hidden-sm-and-down mt-2"
            elevation="0"
            height="47"
            @click="action"
            >Adicionar
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<style scoped>
.image-carousel {
  overflow-y: scroll;
  max-height: 400px;
  padding-right: 5px;
}

.image-carousel::-webkit-scrollbar {
  background-color: #fff;
  width: 8px;
}

.image-carousel::-webkit-scrollbar-thumb {
  background-color: rgba(114, 119, 131, 0.5);
  border-radius: 20px;
}

.attributes {
  overflow-y: scroll;
  max-height: 400px;
  padding-right: 5px;
}

.attributes::-webkit-scrollbar {
  background-color: #fff;
  width: 8px;
  height: 8px;
}

.attributes::-webkit-scrollbar-thumb {
  background-color: rgba(114, 119, 131, 0.5);
  border-radius: 20px;
}

.img {
  cursor: pointer;
  transition: 0.3s;
}

.img:hover {
  box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.2) !important;
}

.btn-add {
  font-weight: bold;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #ffffff;
  transition: 0.3s;

  background: #bc0000 !important;
  border-radius: 10px;
}

.btn-add:hover {
  background: #e8161e !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2) !important;
}

.values-row {
  display: flex;
  overflow-x: scroll;
  padding-bottom: 3px;
}

.values-row::-webkit-scrollbar {
  background-color: #fff;
  height: 8px;
}

.values-row::-webkit-scrollbar-thumb {
  background-color: rgba(114, 119, 131, 0.5);
  border-radius: 20px;
}

.attr-item {
  padding: 12px;
  background: #2d3038;

  white-space: nowrap;

  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.15px;

  color: #ffffff;
}

.ProductName {
  font-weight: bold;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0.15px;
  color: #000000;
}

.ProductCode {
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;

  color: #000000;
}

.label {
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.15px;
  color: #000000;
}

.chips-details {
  background: #2d3038;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  text-align-last: center;
  line-height: 21px;
  letter-spacing: 0.15px;

  color: #ffffff;
}
.v-label {
  font-family: Poppins !important;
  font-style: normal !important;
  font-weight: bold !important;
  font-size: 18px !important;
  line-height: 21px !important;
  letter-spacing: 0.15px !important;

  color: #000000 !important;
}

.v-card__title {
  text-align-last: start !important;
  font-family: Poppins !important;
  font-style: normal !important;
  font-weight: bold !important;
  font-size: 22px !important;
  line-height: 32px !important;
  letter-spacing: 0.13px !important;

  color: #000000 !important;
}
.v-card__subtitle {
  text-align-last: start;
  font-family: Poppins !important;
  font-style: normal !important;
  font-weight: 555 !important;
  font-size: 18px !important;
  line-height: 27px !important;
  letter-spacing: 0.15px !important;

  color: #000000 !important;
}

.linha {
  height: auto;
}

.hooper-list {
  text-align: -webkit-center !important;
}

@media (max-width: 600px) {
  .select-type {
    width: 90% !important;
  }
}

@media (max-width: 600px) {
  .form {
    flex-direction: column;
  }
}
</style>

<script>
import ApiService from "../../../../services/ApiService";

export default {
  props: {
    title: String,
    productId: String,
  },

  data: () => ({
    active: false,
    colors: [],
    attributes: [],
    env_url: "",
    currentProduct: {},
    loading: false,
    apiService: new ApiService(),
    model: null,
    tipos: [],
    product: {},
  }),

  async created() {
    this.env_url = process.env.VUE_APP_BASE_URL;

    await this.getProduct();
  },

  methods: {
    scrollBottom() {
      let target = document.querySelector(
        `#image${this.product.images.length - 1}`
      );
      let scrollContainer = document.querySelector(
        `#image${this.product.images.length - 1}`
      );
      do {
        //find scroll container
        scrollContainer = scrollContainer.parentNode;
        if (!scrollContainer) return;
        scrollContainer.scrollTop += 1;
      } while (scrollContainer.scrollTop == 0);

      var targetY = 0;
      do {
        //find the top of target relatively to the container
        if (target == scrollContainer) break;
        targetY += target.offsetTop;
      } while ((target = target.offsetParent));

      // start scrolling
      this.scroll(scrollContainer, scrollContainer.scrollTop, targetY, 0);
    },

    scroll(c, a, b, i) {
      i++;
      if (i > 30) return;
      c.scrollTop = a + ((b - a) / 30) * i;
      setTimeout(function () {
        scroll(c, a, b, i);
      }, 20);
    },

    chooseSelectedImg(index) {
      this.product.images.splice(0, 0, this.product.images.splice(index, 1)[0]);
    },

    async getProduct() {
      this.loading = true;

      await this.apiService
        .get(`product/get-one?id=` + this.productId)
        .then((response) => {
          this.product = response;

          this.setAttribues();
          this.colorToFirst();
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    setAttribues() {
      this.product.skus.forEach((sku) => {
        sku.attributes.forEach((attribute) => {
          let attr = {
            hex: [],
            values: [],
          };

          let finded = this.attributes.find(
            (x) => x.name == attribute.attribute.name
          );

          if (finded != null) {
            finded.hex.push(attribute.hex);
            finded.values.push(attribute.name);
          } else {
            attr.type = attribute.attribute.type;
            attr.name = attribute.attribute.name;
            attr.hex.push(attribute.hex);
            attr.values.push(attribute.name);
            this.attributes.push(attr);
          }
        });
      });

      this.attributes.map((attr) => {
        attr.hex = [...new Set(attr.hex)];
        attr.values = [...new Set(attr.values)];
      });
    },

    colorToFirst() {
      let findColor = this.attributes.filter((x) => x.type === "Cor");

      if (findColor.length > 0) {
        findColor.map((color) => {
          let idx = this.attributes.findIndex((y) => y == color);
          this.attributes.splice(0, 0, this.attributes.splice(idx, 1)[0]);
        });
      }
    },

    close() {
      this.$emit("close");
    },

    action() {
      this.$emit("action");
    },
  },
};
</script>
